export default "__VITE_ASSET__50898701__"